module.exports = __webpack_public_path__ + "img/internet2.55c52833.png";